import moment from 'moment'
import { LOAD_DEVICE_DETAILS } from '../../constants/commonEvents'
import { USER_ROLES } from '../../constants/userDetails'

angular.module('surfsightApp.controllers').controller('edgeTripsController', [
  '$scope',
  '$state',
  '$http',
  '$filter',
  '$localStorage',
  '$mdDialog',
  'edgeFactoryV2',
  'nominatimLookUp',
  '$stateParams',
  'SystemConstants',
  'UnitSystem',
  '$rootScope',
  function (
    $scope,
    $state,
    $http,
    $filter,
    $localStorage,
    $mdDialog,
    edgeFactoryV2,
    nominatimLookUp,
    $stateParams,
    SystemConstants,
    UnitSystem,
    $rootScope
  ) {
    var $translate = $filter('translate')
    $scope.noTrips = false
    $scope.edge_trip_message = ''
    const edge_id = $stateParams.edge_id
    const deviceImei = edge_id
    var timeFormat = 2
    if ($localStorage.timeFormat) {
      timeFormat = $localStorage.timeFormat
    }
    $scope.tripSearch = {
      id: 1,
      name: 'today',
      name_formate1: 'today',
      name_formate2: Date.today().toString('MMM dd '),
      date: {
        start: Date.today().getTime(),
        end: Date.today()
          .add(1)
          .day()
          .getTime()
      }
    }
    var selected_time = {
      range: {
        start: $scope.tripSearch.date.start,
        end: $scope.tripSearch.date.end
      },
      value: -1
    }
    $scope.trips = []
    let [edge] = edgeFactoryV2.list.filter(e => e.imei === deviceImei)
    $scope.edge = edge
    $scope.loadTrips = function () {
      $scope.trips = []
      const params = {
        start: moment($scope.tripSearch.date.start).format(),
        end: moment($scope.tripSearch.date.end).format()
      }
      const requestJson = {
        method: 'GET',
        url: `${V2_BASEURL}/devices/${deviceImei}/trips`,
        params
      }
      $scope.edge_trips_loading = true
      $http(requestJson)
        .then(function (response) {
          $scope.trips = response.data.data.reverse()
          $scope.updateTripsData()
        })
        .catch(handleServerError)
        .finally(() => {
          $scope.edge_trips_loading = false
        })
    }
    if ($scope.edge) {
      $scope.loadTrips()
      $scope.$emit('mapHistoryEvent', {
        edge: edge,
        selected_time: selected_time
      })
    } else {
      $scope.$emit(LOAD_DEVICE_DETAILS.REQUEST, { imei: deviceImei })
      $scope.$on(LOAD_DEVICE_DETAILS.RESPONSE, function (e, data) {
        if (data.imei === deviceImei) {
          ;[edge] = edgeFactoryV2.list.filter(e => e.imei === deviceImei)
          $scope.edge = edge
          $scope.loadTrips()
          $scope.$emit('mapHistoryEvent', {
            edge: edge,
            selected_time: selected_time
          })
        }
      })
    }
    $scope.updateTripsData = function () {
      let requestData = ''
      $scope.trips.forEach(function (trip, index) {
        edge = $scope.edge
        $scope.noTrips = false
        let maxSpeedDisplay = Math.round(trip.max_speed * 3.6 * 10) / 10
        $scope.trips[index].distance_val = parseFloat(
          (trip.distance * 1.609344).toFixed(2)
        )
        let distanceDisplay = parseFloat((trip.distance * 1.609344).toFixed(2))
        $scope.trips[index].max_speed_display = maxSpeedDisplay + ' KM'
        $scope.trips[index].distance_display = distanceDisplay
        let durationDisplay = getTripDurationText(trip.duration)
        $scope.trips[index].duration_display = durationDisplay
        var fromTime = new Date(trip.start.time * 1000).toString(
          'MMM-dd, HH:mm'
        )
        var toTime = new Date(trip.end.time * 1000).toString('MMM-dd, HH:mm')

        if (timeFormat == 2) {
          var startTime = new Date(trip.start.time * 1000).toString('hh:mm tt')
          var endTime = new Date(trip.end.time * 1000).toString('hh:mm tt')
        } else {
          startTime = new Date(trip.start.time * 1000).toString('HH:mm ')
          endTime = new Date(trip.end.time * 1000).toString('HH:mm ')
        }
        var startDate = new Date(trip.start.time * 1000).toString('dd/MM/yy')
        var endDate = new Date(trip.end.time * 1000).toString('dd/MM/yy')
        $scope.trips[index].fromTime = fromTime
        $scope.trips[index].toTime = toTime
        $scope.trips[index].startTime = startTime
        $scope.trips[index].endTime = endTime
        $scope.trips[index].startDate = startDate
        $scope.trips[index].endDate = endDate
        $scope.trips[index].tripSelected = false
        ;['start', 'end'].forEach(function (start_end, i) {
          const locationId = index * 2 + i
          requestData +=
            `id=${locationId}&at=${trip[start_end]['lat']}` +
            `,${trip[start_end]['lon']}\n`
        })
      })
      // updating trip addresses
      const splitRequestData = requestData.split('\n')
      let locationRequestsCount = splitRequestData.length - 1
      let batch = 100
      for (let j = 0; j < locationRequestsCount; j = j + batch) {
        let currentLocationRequests = splitRequestData.slice(j, j + batch)
        nominatimLookUp
          .reverseLookupMultiple(currentLocationRequests.join('\n'))
          .then(locationsData => {
            requestData = ''
            $scope.trips = locationsData.results.reduce(
              (_trips, locationData) => {
                const [firstLocation] = locationData.items
                const locationId = Number(locationData.id)
                const tripIndex = Math.floor(locationId / 2)
                const key = locationId % 2 === 0 ? 'start' : 'end'
                if (!_trips[tripIndex] || !_trips[tripIndex][key]) return _trips
                _trips[tripIndex][key].address = firstLocation
                  ? firstLocation.title
                  : `${parseInt(1000000 * _trips[tripIndex][key].lat) /
                      1000000},${parseInt(
                      1000000 * _trips[tripIndex][key].lon
                    ) / 1000000}`
                return _trips
              },
              $scope.trips
            )
          })
      }
      $scope.$emit('tripsData', {
        tripsData: $scope.trips,
        edge_id: edge_id,
        tripSearch: $scope.tripSearch
      })
    }
    $scope.showTripsDateFilter = ev => {
      $mdDialog
        .show({
          controller: 'EdgeTripDateFilter',
          templateUrl:
            './templates/edge.trip.date.filter.view.html?t=' +
            window.webpackHash,
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(function (response) {
          $scope.tripSearch = response
          $scope.loadTrips()
          $scope.mapLoadingStatus = true
          $scope.$emit('mapHistoryEvent', {
            edge: $scope.edge,
            selected_time: {
              range: {
                start: response.date.start,
                end: response.date.end
              },
              value: -1
            }
          })
        })
    }
    $scope.hideTripsSidenav = function () {
      $rootScope.$broadcast('closeAllBroadcasts', {})
      $rootScope.$broadcast('closeMapMediaPlayers', {})
      $state.go('home.common.maps.view')
    }
    $scope.showMapHistoryOnMap = function () {
      $scope.$emit('mapEvent', { edge_id })
    }
    $scope.scrollbarConfig = {
      theme: 'dark-2',
      scrollInertia: 500,
      scrollButtons: {
        scrollAmount: 'auto', // scroll amount when button pressed
        enable: false // enable scrolling buttons by default
      }
    }
    $scope.selectedTrips = function (trip, eventVal, index) {
      $scope.trips.forEach(function (t, i) {
        t.tripSelected = false
      })
      $scope.trips[index].tripSelected = true
      $scope.$emit('selectedTrips', {
        tripsData: trip,
        eventVal: eventVal,
        edge_id: edge_id
      })
    }
    $scope.exportReport = () => {
      $scope.edge_trips_loading = true
      $scope.reportName = getReportName()
      const headers = {
        startDate: $translate('startDate'),
        startTime: $translate('startTime'),
        startPositionLatLon: $translate('startPositionLatLon'),
        startLocation: $translate('startLocation'),
        endDate: $translate('endDate'),
        endTime: $translate('endTime'),
        endPositionLatLon: $translate('endPositionLatLon'),
        endLocation: $translate('endLocation'),
        distance: `${$translate('distance')} (${UnitSystem.value(
          1,
          'km',
          '$l'
        ).trim()})`,
        duration: $translate('duration'),
        numEventsPerTrip: $translate('numEventsPerTrip'),
        driverDetails: $translate('driverDetails')
      }
      const report = $scope.trips.map(trip => {
        return {
          [headers.startDate]: trip.startDate,
          [headers.startTime]: trip.startTime.trim(),
          [headers.startPositionLatLon]: `${trip.start.lat}, ${trip.start.lon}`,
          [headers.startLocation]: `${trip.start.address}`,
          [headers.endDate]: trip.endDate,
          [headers.endTime]: trip.endTime.trim(),
          [headers.endPositionLatLon]: `${trip.end.lat}, ${trip.end.lon}`,
          [headers.endLocation]: `${trip.end.address}`,
          [headers.distance]: UnitSystem.value(
            trip.distance_display,
            'km',
            '$v'
          ),
          [headers.duration]: trip.duration_display,
          [headers.numEventsPerTrip]: trip.eventsCount,
          [headers.driverDetails]:
            trip.drivers && trip.drivers[0]
              ? `${trip.drivers[0].firstName} ${trip.drivers[0].lastName}`.trim()
              : '-'
        }
      })
      $scope.edge_trips_loading = false
      return report
    }
    $scope.reportName = ''
    const getReportName = () => {
      let dateString
      const startDate = new Date($scope.tripSearch.date.start)
      const endDate = new Date($scope.tripSearch.date.end)
      if ([1, 2].includes($scope.tripSearch.id)) {
        dateString = startDate.toString('MMM-dd-yyyy')
      } else {
        dateString = `${startDate.toString('MMM-dd-yyyy')}-${endDate.toString(
          'MMM-dd-yyyy'
        )}`
      }
      return (
        `${$scope.edge.name} ` +
        `${$scope.edge.imei} ` +
        `${$translate('trips')} ` +
        `${dateString}.csv`
      ).replace(/ /g, '-')
    }

    function handleServerError (response) {
      $scope.$emit('handleServerError', response)
    }

    $scope.UnitSystem = UnitSystem
    if ($localStorage.measurementUnits === 1) {
      SystemConstants.unit = 1
    } else {
      SystemConstants.unit = 0
    }
  }
])
